export const ROUTER_QUERY_KEY = 'path';
